// extracted by mini-css-extract-plugin
export default {"rightControlsStyle":"StaffEquipment_rightControlsStyle__2JJDy"};